import { render, staticRenderFns } from "./comp_CheckoutStep-contact.vue?vue&type=template&id=4047e874&scoped=true&"
import script from "./comp_CheckoutStep-contact.vue?vue&type=script&lang=js&"
export * from "./comp_CheckoutStep-contact.vue?vue&type=script&lang=js&"
import style0 from "./comp_CheckoutStep-contact.vue?vue&type=style&index=0&id=4047e874&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4047e874",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtnToggle,VCard,VCol,VDivider,VRadio,VRadioGroup,VRow,VSpacer})
